import { APP_VERSION, APP_BRAND } from '../consts';
import analytics from './firebaseAnalytics';
import { logEvent } from 'firebase/analytics';
import { useApolloClient } from '@apollo/client';
import { UserDataQuery, formatIsoDate } from '@front-activerse/common-components';
import { useAuth } from '@front-activerse/common-components';

const withFirebase = (ChildComponent) => (props) => {
  const client = useApolloClient();
  const isAuth = useAuth();
  const mobileApp = JSON.parse(window.localStorage.getItem('mobileApp'));

  const trackFirebaseEvent = (eventName, eventParams = null) => {
    const mobileAppOs = mobileApp.os;
    const newParams = {
      ...eventParams,
      app_info: APP_VERSION,
      app_brand: APP_BRAND,
      app_platform: mobileApp.active ? `webview-${mobileAppOs}` : 'web',
    };

    if (isAuth) {
      const userData = client.readQuery({
        query: UserDataQuery,
        variables: { date: formatIsoDate(new Date()) },
      });

      if (userData && userData.me && userData.me.id) {
        newParams.user_ID = `${userData.me.id}`;
      }
    }

    logEvent(analytics, eventName, newParams);
  };

  return <ChildComponent {...props} trackFirebaseEvent={trackFirebaseEvent} />;
};

export default withFirebase;
